import { useState, useEffect, useMemo } from "react";
import React from "react";
import axios from "axios";
import { GET_USER_ANSWER } from "../../services/constants";
import { DottLoader } from "../../Mycomponent/share/loader";
import CustomTable from "../../Mycomponent/share/customTable";
import { CSVLink } from "react-csv";
import { Button } from "@mui/material";
import { ZustandStore } from "../../store/zustand-store";

const UserQuesAns = () => {
  const [data, setData] = useState({
    loading: true,
    error: false,
    data: [],
  });
  const [page, setPage] = React.useState(1);
  const { isAdminPerformAction } = ZustandStore((state) => state);

  useEffect(() => {
    axios
      .get(GET_USER_ANSWER())
      .then((response) => {
        const data = response.data;
        if (data?.length > 0) {
          setData({
            loading: false,
            error: false,
            data: data.reverse(),
          });
        } else {
          setData({
            loading: false,
            error: false,
            data: [],
          });
        }
      })
      .catch(() => {
        setData({
          loading: false,
          error: true,
          data: [],
        });
      });
  }, []);

  const tableHeader = useMemo(() => {
    return [
      {
        label: "EMAIL",
        key: "email",
        minWidth: 120,
        align: "left",
        width: "18%",
      },
      {
        label: "ORGANISATION",
        key: "organisation",
        minWidth: 120,
        width: "18%",
        align: "left",
      },
      {
        label: "EXPERIENCE",
        key: "experience",
        minWidth: 120,
        width: "18%",
        align: "left",
      },
      {
        label: "EMP_SIZE",
        key: "emp_size",
        minWidth: 120,
        width: "13%",
        align: "center",
      },
      {
        label: "TOOLS",
        key: "tools",
        minWidth: 120,
        width: "13%",
        align: "center",
      },
      {
        label: "Referral",
        key: "referral",
        minWidth: 120,
        width: "20%",
        align: "center",
      },
    ];
  }, []);

  function createData(
    id,
    email,
    organisation,
    experience,
    emp_size,
    tools,
    referral
  ) {
    return {
      id,
      email,
      organisation,
      experience,
      emp_size,
      tools,
      referral,
    };
  }

  const rows = useMemo(() => {
    if (data.data?.length === 0) return [];
    return data.data?.map((item, index) => {
      return createData(
        index,
        item?.email,
        item.answer.organisation,
        item.answer.experience,
        item.answer.emp_size,
        item.answer.tools,
        item.answer.referral || "-"
      );
    });
  }, [data.data]);

  const loadCSVData = () => {
    if (data?.data?.length === 0) return [];
    return data?.data?.map((item) => {
      const obj = {
        email: item.email,
        organisation: item.answer.organisation,
        experience: item.answer.experience,
        emp_size: item.answer.emp_size,
        tools: item.answer.tools,
        referral: item.answer.referral,
      };
      return obj;
    });
  };

  if (data.loading) {
    return (
      <>
        <h1 className="table_title font-bold heading-large mb-4">Users</h1>
        <DottLoader />
      </>
    );
  }

  return (
    <>
      <CustomTable
        showSearchBar={true}
        tableHeader={tableHeader}
        rows={rows}
        page={page}
        setPage={setPage}
        tableTitle="User Answer"
        downloadCSVFile={
          isAdminPerformAction?.isPerformAction && (
            <CSVLink
              data={loadCSVData()}
              filename={"SEO Tools: user-answers.csv"}
            >
              <Button className="btn_1 ms-2">Download CSV</Button>
            </CSVLink>
          )
        }
      />
    </>
  );
};

export default UserQuesAns;
